<template>
<div>
    <!-- <TheNavigationPanel/> -->
    <paystack
        :amount="amount"
        :email="email"
        :paystackkey="paystackkey"
        :reference="reference"
        :callback="callback"
        :close="close"
        :embed="false"
    >
       <i class="fas fa-money-bill-alt"></i>
       Make Payment
    </paystack>
   
</div>
   
</template>
<script type="text/javascript">
    // import TheNavigationPanel from '../components/TheNavigationPanel';
    import paystack from 'vue-paystack';
    export default {
        name: 'paystackview',
        components: {
            paystack,
            // TheNavigationPanel,
        },

        data: () => ({
            paystackkey: "pk_test_703ef638e11c6db14b0a89a4a1d8bccd45f8f427", //paystack public key
            email: 'info@360trendies.com', // Customer email
            amount: 1000000 // in kobo
        }),
         computed: {
        reference(){
            let text = "";
            let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

            for( let i=0; i < 10; i++ )
            text += possible.charAt(Math.floor(Math.random() * possible.length));

            return text;
        }
        },
        methods: {
        callback: function(response){
            console.log(response)
        },
        close: function(){
            console.log("Payment closed")
        }
        }
            
    }
</script>